package com.macrofocus.eflux.network

import web.cssom.ClassName
import web.dom.DOMTokenList

class VoltageClass(private val tokens: DOMTokenList<ClassName>?) {
    var value: ClassName? = tokens?.voltage
        set(value) {
            if(field != value) {
                if(value != null)
                    tokens?.add(value)
                if(field != null)
                    tokens?.remove(field!!)
                field = value
            }
        }
}